var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5283 0L13.1174 2.88653L16.9562 2.33956L17.0841 6.215L20.3764 8.26352L17.9833 11.3145L19.1886 15L15.3942 15.799L13.9485 19.3969L10.5283 17.57L7.10812 19.3969L5.66242 15.799L1.86807 15L3.07333 11.3145L0.680243 8.26352L3.97251 6.215L4.10044 2.33956L7.93923 2.88653L10.5283 0Z",
    fill: "#68A14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8096 6.71875L7.24707 13.2812",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9502 8.59375C8.5974 8.59375 9.12207 8.06908 9.12207 7.42188C9.12207 6.77467 8.5974 6.25 7.9502 6.25C7.30299 6.25 6.77832 6.77467 6.77832 7.42188C6.77832 8.06908 7.30299 8.59375 7.9502 8.59375Z",
    fill: "#68A14B",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1064 13.75C13.7537 13.75 14.2783 13.2253 14.2783 12.5781C14.2783 11.9309 13.7537 11.4062 13.1064 11.4062C12.4592 11.4062 11.9346 11.9309 11.9346 12.5781C11.9346 13.2253 12.4592 13.75 13.1064 13.75Z",
    fill: "#68A14B",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.7afe2e97e4fe069aa32bf3f2c6158b78.svg";
export { ForwardRef as ReactComponent };